import { useState, useEffect } from 'react';
import { AuthUser } from '../types';
import { auth } from '../lib/auth';

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(auth.getCurrentUser());
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChange((user) => {
      setUser(user);
      setIsLoading(false);
    });

    return unsubscribe;
  }, []);

  const signUp = async (email: string, password: string, username: string, displayName: string) => {
    setLoading(true);
    try {
      const user = await auth.signUp(email, password, username, displayName);
      return user;
    } finally {
      setLoading(false);
    }
  };

  const signIn = async (email: string, password: string) => {
    setLoading(true);
    try {
      const user = await auth.signIn(email, password);
      return user;
    } finally {
      setLoading(false);
    }
  };

  const signOut = async () => {
    setLoading(true);
    try {
      await auth.signOut();
    } finally {
      setLoading(false);
    }
  };

  return {
    user,
    loading,
    isLoading,
    signUp,
    signIn,
    signOut,
    isAuthenticated: auth.isAuthenticated()
  };
}